module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-81c31b20!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Model.Sellers.vue
// module id = 798
// module chunks = 2